<form [formGroup]="formGroup">
  <div class="p-card-header flex p-3 gap-2 align-items-center">
    <h3 class="mr-3">{{pageTitle}}</h3>
    <p-select
      [options]="profiles"
      optionLabel="name"
      optionValue="sapProfileId"
      [(ngModel)]="sapProfileId"
      (onChange)="onProfileChanged($event)"
      [ngModelOptions]="{standalone: true}"
    >
    </p-select>
    <div class="flex align-items-center">
      <p-button
        [text]="true"
        pTooltip="Create New"
        icon="pi pi-plus"
        (click)="createProfile()"
      ></p-button>
      <p-button
        *ngIf="profile"
        [text]="true"
        icon="pi pi-trash"
        severity="danger"
        mwlConfirmationPopover
        [title]="'Delete Selected SAP Profile'"
        [popoverMessage]="
              'You are going to delete selected SAP Profile. Are you sure?'
            "
        [appendToBody]="true"
        [confirmText]="'Yes'"
        [cancelText]="'No'"
        placement="bottom"
        (confirm)="removeProfile()"
      ></p-button>
    </div>
    <mat-form-field style="width: 50%">
      <mat-label>Name</mat-label>
      <input matInput name="name" formControlName="name" required />
    </mat-form-field>
    <p-button
      [text]="true"
      icon="pi pi-save"
      (click)="onDone()"
      *ngIf="profile"
    ></p-button>
  </div>
  <div style="display: flex; flex-direction: column;" id="sapProfileLayoutDiv" *ngIf="profile">
    <div>
      <mat-horizontal-stepper [linear]="false">
        <mat-step label="General Information" [stepControl]="{invalid: false}">
          <div>
            <mat-form-field>
              <mat-label>3PAO/IA Name</mat-label>
              <input matInput formControlName="iaName" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>CSP Name</mat-label>
              <input matInput formControlName="cspName" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>CSO Name</mat-label>
              <input matInput formControlName="csoName" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>SAP Version</mat-label>
              <input matInput formControlName="version" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Date</mat-label>
              <input matInput formControlName="date" [matDatepicker]="pickerDate" required>
              <mat-datepicker-toggle matSuffix [for]="pickerDate"></mat-datepicker-toggle>
              <mat-datepicker #pickerDate></mat-datepicker>
            </mat-form-field>
          </div>
          <p style="font-size:16px;">
            <strong style="padding-right: 10px;">Prepared By</strong>
          </p>
          <div>
            <mat-form-field>
              <mat-label>Name</mat-label>
              <input matInput formControlName="preparedByName" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Address</mat-label>
              <input matInput formControlName="preparedByAddress" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Building</mat-label>
              <input matInput formControlName="preparedByBuilding" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>City</mat-label>
              <input matInput formControlName="preparedByCity" />
            </mat-form-field>
          </div>
          <p style="font-size:16px;">
            <strong style="padding-right: 10px;">Prepared For</strong>
          </p>
          <div>
            <mat-form-field>
              <mat-label>Name</mat-label>
              <input matInput formControlName="preparedForName" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Address</mat-label>
              <input matInput formControlName="preparedForAddress" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Building</mat-label>
              <input matInput formControlName="preparedForBuilding" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>City</mat-label>
              <input matInput formControlName="preparedForCity" />
            </mat-form-field>
          </div>
          <div>
            <button mat-raised-button
                    matStepperPrevious
                    type="button">
              Back
            </button>
            <button mat-raised-button
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button
                    (click)="onDone()">
              Save
            </button>
          </div>
        </mat-step>
        <mat-step label="Project" [stepControl]="{invalid: false}">
          <div>
            <mat-form-field>
              <mat-label>Project</mat-label>
              <mat-select formControlName="projectId" (selectionChange)="projectChanged($event)">
                <mat-option [value]="project.projectId" *ngFor="let project of projects">{{ project.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>IT Profile</mat-label>
              <mat-select formControlName="clientItProfileId">
                <mat-option [value]="itProfile.clientITProfileId"
                            *ngFor="let itProfile of projectItProfiles">{{ itProfile.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <p-table [value]="projectControlItems"
                   dataKey="controlItem.category"
                   selectionMode="multiple"
                   [(selection)]="selectedProjectControlItems">

            <ng-template pTemplate="header">
              <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
                <th style="width: 5em;"></th>
                <th>Category</th>
                <th>Control ID</th>
                <th>Description</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded"
                         let-columns="columns">
              <tr class="ui-widget-header"
                  *ngIf="rowGroupMetadata[item.controlItem.category].index === rowIndex">
                <td colspan="4">
                  <a href="#" [pRowToggler]="item">
                    <i
                      [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                    <span>{{ item.controlItem.complianceArea.name }} - {{ item.controlItem.category }}</span>
                  </a>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="expandedrow" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>
                  <p-checkbox [(ngModel)]="item.checked" [ngModelOptions]="{standalone: true}" binary="true"
                              [readonly]="item.controlItem?.parentControlItemId"></p-checkbox>
                </td>
                <td (click)="item.checked = !item.checked">{{ item.controlItem.category }}</td>
                <td (click)="item.checked = !item.checked">{{ item.controlItem.complianceAreaControlId }}</td>
                <td (click)="item.checked = !item.checked">{{ item.controlItem.description }}</td>
              </tr>
            </ng-template>
          </p-table>

          <div>
            <button mat-raised-button
                    matStepperPrevious
                    type="button">
              Back
            </button>
            <button mat-raised-button
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button
                    (click)="onDone()">
              Save
            </button>
          </div>

        </mat-step>
        <mat-step label="Background, Scope" [stepControl]="{invalid: false}">
          <div>
            <mat-form-field>
              <mat-label>Assessment</mat-label>
              <mat-select formControlName="assessmentType">
                <mat-option [value]="0">an initial assessment</mat-option>
                <mat-option [value]="1">an annual assessment</mat-option>
                <mat-option [value]="2">a combined annual assessment and significant change assessment</mat-option>
                <mat-option [value]="3">a significant change assessment</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Initial Assessment Baseline</mat-label>
              <mat-select formControlName="baselineInitial">
                <mat-option [value]="0">Low</mat-option>
                <mat-option [value]="1">Moderate</mat-option>
                <mat-option [value]="2">High</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Annual Assessment Baseline</mat-label>
              <mat-select formControlName="baselineAnnual">
                <mat-option [value]="0">Low</mat-option>
                <mat-option [value]="1">Moderate</mat-option>
                <mat-option [value]="2">High</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Separate Assessment Plan</mat-label>
              <mat-select formControlName="isAlsoIncludesSignificant">
                <mat-option [value]="false">No</mat-option>
                <mat-option [value]="true">Yes</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>AO/JAB</mat-label>
              <mat-select formControlName="aoJab">
                <mat-option [value]="0">AO</mat-option>
                <mat-option [value]="1">JAB</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Assessment</mat-label>
              <mat-select formControlName="relatedActivities">
                <mat-option [value]="0">all items related to continuous monitoring activities</mat-option>
                <mat-option [value]="1">
                  all items related to continuous monitoring activities as well as those that are
                  applicable to the significant change assessment
                </mat-option>
                <mat-option [value]="2">
                  continuous monitoring activities that are only applicable to the significant
                  change assessment
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Significant Change</mat-label>
              <mat-select formControlName="includingThoseApplicable">
                <mat-option [value]="false">including those applicable to the significant change assessment</mat-option>
                <mat-option [value]="true">applicable only to the significant change assessment</mat-option>
              </mat-select>
            </mat-form-field>
          </div>


          <p-table [value]="assessmentScopes"
                   [rows]="10"
                   selectionMode="single"
                   [paginator]="true"
                   [style]="{'margin-top':'10px'}"
                   sortField="sapScopeId">

            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix">
                <div style="float: left;">Table 3-1 Assessment Scope</div>
                <button type="button"
                        pButton
                        icon="pi pi-plus"
                        (click)="showScopeDialog({packageId : '', csoName : '', cspName : '', kind: 0})"
                        label="Add"
                        class="risksponge-button"
                        style="float:right">
                </button>
              </div>
              <div style="clear:both;"></div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of scopeCols" [pSortableColumn]="col.field"
                    [ngStyle]="{ width: col.width || 'auto' }">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [ngStyle]="{width:'7em'}"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>{{ item.packageId }}</td>
                <td>{{ item.cspName }}</td>
                <td>{{ item.csoName }}</td>
                <td style="white-space: nowrap">
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="showScopeDialog(item)"
                          icon="pi pi-pencil">
                  </button>

                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="deleteScope(item)"
                          icon="pi pi-trash">
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <p-table [value]="leveragedScopes"
                   [rows]="10"
                   selectionMode="single"
                   [paginator]="true"
                   [style]="{'margin-top':'10px'}"
                   sortField="sapScopeId">

            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix">
                <div style="float: left;">Table 3-2 Leveraged Systems CSP/CSO</div>
                <button type="button"
                        pButton
                        icon="pi pi-plus"
                        (click)="showScopeDialog({packageId : '', csoName : '', cspName : '', kind: 1}, leveragedScopes)"
                        label="Add"
                        class="risksponge-button"
                        style="float:right">
                </button>
              </div>
              <div style="clear:both;"></div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of scopeCols" [pSortableColumn]="col.field"
                    [ngStyle]="{ width: col.width || 'auto' }">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [ngStyle]="{width:'7em'}"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>{{ item.packageId }}</td>
                <td>{{ item.cspName }}</td>
                <td>{{ item.csoName }}</td>
                <td style="white-space: nowrap">
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="showScopeDialog(item, leveragedScopes)"
                          icon="pi pi-pencil">
                  </button>

                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="deleteScope(item, assessmentScopes)"
                          icon="pi pi-trash">
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <p-table [value]="profile.sapLocations"
                   [rows]="10"
                   selectionMode="single"
                   [paginator]="true"
                   [style]="{'margin-top':'10px'}"
                   sortField="sapLocationId">

            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix">
                <div style="float: left;">Table 3-3 Location of Components</div>
                <button type="button"
                        pButton
                        icon="pi pi-plus"
                        (click)="showLocationDialog()"
                        label="Add"
                        class="risksponge-button"
                        style="float:right">
                </button>
              </div>
              <div style="clear:both;"></div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of locationCols" [pSortableColumn]="col.field"
                    [ngStyle]="{ width: col.width || 'auto' }">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [ngStyle]="{width:'7em'}"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>{{ item.name }}</td>
                <td>{{ item.address }}</td>
                <td>{{ item.description }}</td>
                <td style="white-space: nowrap">
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="showLocationDialog(item)"
                          icon="pi pi-pencil">
                  </button>

                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="deleteLocation(item)"
                          icon="pi pi-trash">
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <div>
            <button mat-raised-button
                    matStepperPrevious
                    type="button">
              Back
            </button>
            <button mat-raised-button
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button
                    (click)="onDone()">
              Save
            </button>
          </div>
        </mat-step>
        <mat-step label="Assumptions, Methodology" [stepControl]="{invalid: false}">
          <div>
            <mat-form-field>
              <mat-label>Validated by IA Controls</mat-label>
              <textarea matInput
                        type="text"
                        formControlName="validatedControls">
                            </textarea>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Alternative Control Implementations</mat-label>
              <textarea matInput
                        type="text"
                        formControlName="alternativeControlImplementation">
                            </textarea>
            </mat-form-field>
          </div>
          <div>
            <mat-checkbox formControlName="willUseSampling">
              Will use sampling when performing vulnerability scanning
            </mat-checkbox>
          </div>
          <div>
            <mat-checkbox formControlName="willUseSamplingControls">
              Will use sampling when testing the following
              controls
            </mat-checkbox>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Sampling Testing Controls</mat-label>
              <textarea matInput
                        type="text"
                        formControlName="samplingControls">
                            </textarea>
            </mat-form-field>
          </div>

          <p-table [value]="profile.sapRoleTestingExclusions"
                   [rows]="10"
                   selectionMode="single"
                   [paginator]="true"
                   [style]="{'margin-top':'10px'}"
                   sortField="roleTestingExclusionId">

            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix">
                <div style="float: left;">Table 3-4 Exclusions for Role Testing</div>
                <button type="button"
                        pButton
                        icon="pi pi-plus"
                        (click)="showRoleTestingExclusionDialog()"
                        label="Add"
                        class="risksponge-button"
                        style="float:right">
                </button>
              </div>
              <div style="clear:both;"></div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of roleTestingExclusionCols" [pSortableColumn]="col.field"
                    [ngStyle]="{ width: col.width || 'auto' }">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [ngStyle]="{width:'7em'}"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>{{ item.roleType }}</td>
                <td>{{ item.exclusionReason }}</td>
                <td style="white-space: nowrap">
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="showRoleTestingExclusionDialog(item)"
                          icon="pi pi-pencil">
                  </button>

                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="deleteRoleTestingExclusion(item)"
                          icon="pi pi-trash">
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <div>
            <button mat-raised-button
                    matStepperPrevious
                    type="button">
              Back
            </button>
            <button mat-raised-button
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button
                    (click)="onDone()">
              Save
            </button>
          </div>
        </mat-step>
        <mat-step label="Test Plan, Rules of Engagement" [stepControl]="{invalid: false}">
          <div>
            <mat-form-field>
              <mat-label>CAPTCHA Description</mat-label>
              <input matInput formControlName="captchaDescription" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>OCSP Description</mat-label>
              <input matInput formControlName="oscpDescription" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>End of Testing Notified Person</mat-label>
              <input matInput formControlName="testingNotified" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Communication of Test Result Days Limit</mat-label>
              <input matInput type="number"
                     formControlName="withinTestingDays" />
            </mat-form-field>
          </div>

          <p-table [value]="profile.sapSecurityAssessments"
                   [rows]="10"
                   selectionMode="single"
                   [paginator]="true"
                   [style]="{'margin-top':'10px'}"
                   sortField="sapSecurityAssessmentId">

            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix">
                <div style="float: left;">Table 6-1 Security Assessment Team</div>
                <button type="button"
                        pButton
                        icon="pi pi-plus"
                        (click)="showSecurityAssessmentDialog()"
                        label="Add"
                        class="risksponge-button"
                        style="float:right">
                </button>
              </div>
              <div style="clear:both;"></div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of securityAssessmentCols" [pSortableColumn]="col.field"
                    [ngStyle]="{ width: col.width || 'auto' }">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [ngStyle]="{width:'7em'}"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>{{ item.name }}</td>
                <td>{{ item.role }}</td>
                <td>{{ item.validatedByIA }}</td>
                <td>{{ item.validatedByCSP }}</td>
                <td style="white-space: nowrap">
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="showSecurityAssessmentDialog(item)"
                          icon="pi pi-pencil">
                  </button>

                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="deleteSecurityAssessment(item)"
                          icon="pi pi-trash">
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <p-table [value]="profile.sapContacts"
                   [rows]="10"
                   selectionMode="single"
                   [paginator]="true"
                   [style]="{'margin-top':'10px'}"
                   sortField="sapContactId">

            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix">
                <div style="float: left;">Table 6-2 Points of Contact</div>
                <button type="button"
                        pButton
                        icon="pi pi-plus"
                        (click)="showContactDialog()"
                        label="Add"
                        class="risksponge-button"
                        style="float:right">
                </button>
              </div>
              <div style="clear:both;"></div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of contactCols" [pSortableColumn]="col.field"
                    [ngStyle]="{ width: col.width || 'auto' }">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [ngStyle]="{width:'7em'}"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>{{ item.name }}</td>
                <td>{{ item.role }}</td>
                <td style="white-space: nowrap">
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="showContactDialog(item)"
                          icon="pi pi-pencil">
                  </button>

                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="deleteContact(item)"
                          icon="pi pi-trash">
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <p-table [value]="profile.sapAssessmentTools"
                   [rows]="10"
                   selectionMode="single"
                   [paginator]="true"
                   [style]="{'margin-top':'10px'}"
                   sortField="sapAssessmentToolId">

            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix">
                <div style="float: left;">Table 6-3 Assessment Tools</div>
                <button type="button"
                        pButton
                        icon="pi pi-plus"
                        (click)="showAssessmentToolDialog()"
                        label="Add"
                        class="risksponge-button"
                        style="float:right">
                </button>
              </div>
              <div style="clear:both;"></div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of assessmentToolCols" [pSortableColumn]="col.field"
                    [ngStyle]="{ width: col.width || 'auto' }">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [ngStyle]="{width:'7em'}"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>{{ item.name }}</td>
                <td>{{ item.vendor }}</td>
                <td>{{ item.purpose }}</td>
                <td style="white-space: nowrap">
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="showAssessmentToolDialog(item)"
                          icon="pi pi-pencil">
                  </button>

                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="deleteAssessmentTool(item)"
                          icon="pi pi-trash">
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <p-table [value]="profile.sapTests"
                   [rows]="10"
                   selectionMode="single"
                   [paginator]="true"
                   [style]="{'margin-top':'10px'}"
                   sortField="sapTestId">

            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix">
                <div style="float: left;">Table 6-4 Testing Performed Through Manual Methods</div>
                <button type="button"
                        pButton
                        icon="pi pi-plus"
                        (click)="showTestDialog()"
                        label="Add"
                        class="risksponge-button"
                        style="float:right">
                </button>
              </div>
              <div style="clear:both;"></div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of testCols" [pSortableColumn]="col.field"
                    [ngStyle]="{ width: col.width || 'auto' }">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [ngStyle]="{width:'7em'}"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>{{ item.testId }}</td>
                <td>{{ item.testName }}</td>
                <td>{{ item.description }}</td>
                <td style="white-space: nowrap">
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="showTestDialog(item)"
                          icon="pi pi-pencil">
                  </button>

                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="deleteTest(item)"
                          icon="pi pi-trash">
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <div>
            <button mat-raised-button
                    matStepperPrevious
                    type="button">
              Back
            </button>
            <button mat-raised-button
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button
                    (click)="onDone()">
              Save
            </button>
          </div>
        </mat-step>
        <mat-step label="Signatures" [stepControl]="{invalid: false}">
          <div>
            <mat-form-field>
              <mat-label>IA Representative Print</mat-label>
              <input matInput formControlName="iaRepresentativePrint" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>IA Representative Signature</mat-label>
              <input matInput formControlName="iaRepresentativeSignature" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>IA Representative Date</mat-label>
              <input matInput formControlName="iaRepresentativeDate" [matDatepicker]="pickerIaDate"
                     required>
              <mat-datepicker-toggle matSuffix [for]="pickerIaDate"></mat-datepicker-toggle>
              <mat-datepicker #pickerIaDate></mat-datepicker>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>CSP Representative Print</mat-label>
              <input matInput formControlName="cspRepresentativePrint" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>CSP Representative Signature</mat-label>
              <input matInput formControlName="cspRepresentativeSignature" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>CSP Representative Date</mat-label>
              <input matInput formControlName="cspRepresentativeDate" [matDatepicker]="pickerCspDate"
                     required>
              <mat-datepicker-toggle matSuffix [for]="pickerCspDate"></mat-datepicker-toggle>
              <mat-datepicker #pickerCspDate></mat-datepicker>
            </mat-form-field>
          </div>

          <p-table [value]="profile.sapAttackVectors"
                   [rows]="10"
                   selectionMode="single"
                   [paginator]="true"
                   [style]="{'margin-top':'10px'}"
                   sortField="sapAttackVectorId">

            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix">
                <div style="float: left;">Table C-1 Mandatory and Additional Attack Vectors</div>
                <button type="button"
                        pButton
                        icon="pi pi-plus"
                        (click)="showAttackVectorDialog()"
                        label="Add"
                        class="risksponge-button"
                        style="float:right">
                </button>
              </div>
              <div style="clear:both;"></div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of attackVectorCols" [pSortableColumn]="col.field"
                    [ngStyle]="{ width: col.width || 'auto' }">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [ngStyle]="{width:'7em'}"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>{{ item.include ? 'X' : '' }}</td>
                <td>{{ item.name }}</td>
                <td>{{ attackVectorKinds[item.attackVectorKind] }}</td>
                <td style="white-space: nowrap">
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="showAttackVectorDialog(item)"
                          icon="pi pi-pencil">
                  </button>

                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="deleteAttackVector(item)"
                          icon="pi pi-trash">
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <p-table [value]="profile.sapRoleTestings"
                   [rows]="10"
                   selectionMode="single"
                   [paginator]="true"
                   [style]="{'margin-top':'10px'}"
                   sortField="sapRoleTestingId">

            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix">
                <div style="float: left;">Table 3-3 RoleTesting of Components</div>
                <button type="button"
                        pButton
                        icon="pi pi-plus"
                        (click)="showRoleTestingDialog()"
                        label="Add"
                        class="risksponge-button"
                        style="float:right">
                </button>
              </div>
              <div style="clear:both;"></div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of roleTestingCols" [pSortableColumn]="col.field"
                    [ngStyle]="{ width: col.width || 'auto' }">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [ngStyle]="{width:'7em'}"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>{{ item.roleName }}</td>
                <td>{{ item.testUserId }}</td>
                <td>{{ item.associatedFunctions }}</td>
                <td style="white-space: nowrap">
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="showRoleTestingDialog(item)"
                          icon="pi pi-pencil">
                  </button>

                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="deleteRoleTesting(item)"
                          icon="pi pi-trash">
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <div>
            <button mat-raised-button
                    matStepperPrevious
                    type="button">
              Back
            </button>
            <button mat-raised-button
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button
                    (click)="onDone()">
              Save
            </button>
          </div>
        </mat-step>
        <mat-step label="Attachments" [stepControl]="{invalid: false}">
          <p style="font-size:16px;">
            <strong>
              a. FedRAMP CSO Security Controls Selection Worksheet
            </strong>
          </p>
          <div style="margin-bottom: 10px">
            <div *ngIf="!csoSecuritySelection">
              <label class="mat-button mat-raised-button" for="addcsoSecuritySelectionFile">
                <i class="pi pi-paperclip"></i> Attach FedRAMP CSO Security Controls Selection Worksheet
                <input id="addcsoSecuritySelectionFile"
                       type="file"
                       (change)="addSapProfileAttachments($event, 1)"
                       name="addcsoSecuritySelectionFile"
                       style="display: none;" />
              </label>
            </div>
            <div *ngIf="csoSecuritySelection">
              <span (click)="downloadAttachmentFile(1)"
                    class="btn btn-link">
                <img style="max-width: 100px; max-height: 100px;"
                     [attr.src]="api + '/api/attachments/file?name='+ window.encodeURIComponent(this.csoSecuritySelection) + '&path=Account/IT%20Profile&token=' + token" />
                {{ csoSecuritySelection }}
              </span>
              <label class="mat-button mat-raised-button" for="updatecsoSecuritySelectionFile">
                <i class="pi pi-paperclip"></i> Upload new FedRAMP CSO Security Controls Selection Worksheet
                <input id="updatecsoSecuritySelectionFile"
                       type="file"
                       (change)="addSapProfileAttachments($event, 1)"
                       name="updatecsoSecuritySelectionFile"
                       style="display: none;" />
              </label>
              <label class="mat-button mat-raised-button"
                     mwlConfirmationPopover
                     [title]="'Remove FedRAMP CSO Security Controls Selection Worksheet'"
                     [popoverMessage]="'You are going to remove FedRAMP CSO Security Controls Selection Worksheet. Are you sure?'"
                     [appendToBody]="true"
                     [confirmText]="'Yes'" [cancelText]="'No'" placement="top" (confirm)="csoSecuritySelection=null">
                <i class="pi pi-trash"></i>
                Remove FedRAMP CSO Security Controls Selection Worksheet
              </label>
            </div>
          </div>
          <p style="font-size:16px;">
            <strong>
              b. Security Control Sampling Methodology
            </strong>
          </p>
          <div style="margin-bottom: 10px">
            <div *ngIf="!securityControlSampling">
              <label class="mat-button mat-raised-button" for="addsecurityControlSamplingFile">
                <i class="pi pi-paperclip"></i> Attach Security Control Sampling Methodology
                <input id="addsecurityControlSamplingFile"
                       type="file"
                       (change)="addSapProfileAttachments($event, 2)"
                       name="addsecurityControlSamplingFile"
                       style="display: none;" />
              </label>
            </div>
            <div *ngIf="securityControlSampling">
              <span (click)="downloadAttachmentFile(2)"
                    class="btn btn-link">
                <img style="max-width: 100px; max-height: 100px;"
                     [attr.src]="api + '/api/attachments/file?name='+ window.encodeURIComponent(this.securityControlSampling) + '&path=Account/IT%20Profile&token=' + token" />
                {{ securityControlSampling }}
              </span>
              <label class="mat-button mat-raised-button" for="updatesecurityControlSamplingFile">
                <i class="pi pi-paperclip"></i> Upload new Security Control Sampling Methodology
                <input id="updatesecurityControlSamplingFile"
                       type="file"
                       (change)="addSapProfileAttachments($event, 2)"
                       name="updatesecurityControlSamplingFile"
                       style="display: none;" />
              </label>
              <label class="mat-button mat-raised-button"
                     mwlConfirmationPopover
                     [title]="'Remove Security Control Sampling Methodology'"
                     [popoverMessage]="'You are going to remove Security Control Sampling Methodology. Are you sure?'"
                     [appendToBody]="true"
                     [confirmText]="'Yes'" [cancelText]="'No'" placement="top" (confirm)="securityControlSampling=null">
                <i class="pi pi-trash"></i>
                Remove Security Control Sampling Methodology
              </label>
            </div>
          </div>
          <p style="font-size:16px;">
            <strong>
              c. Penetration Testing Plan and Methodology
            </strong>
          </p>
          <div style="margin-bottom: 10px">
            <div *ngIf="!penetrationTestingPlan">
              <label class="mat-button mat-raised-button" for="addpenetrationTestingPlanFile">
                <i class="pi pi-paperclip"></i> Attach Penetration Testing Plan and Methodology
                <input id="addpenetrationTestingPlanFile"
                       type="file"
                       (change)="addSapProfileAttachments($event, 3)"
                       name="addpenetrationTestingPlanFile"
                       style="display: none;" />
              </label>
            </div>
            <div *ngIf="penetrationTestingPlan">
              <span (click)="downloadAttachmentFile(3)"
                    class="btn btn-link">
                <img style="max-width: 100px; max-height: 100px;"
                     [attr.src]="api + '/api/attachments/file?name='+ window.encodeURIComponent(this.penetrationTestingPlan) + '&path=Account/IT%20Profile&token=' + token" />
                {{ penetrationTestingPlan }}
              </span>
              <label class="mat-button mat-raised-button" for="updatepenetrationTestingPlanFile">
                <i class="pi pi-paperclip"></i> Upload new Penetration Testing Plan and Methodology
                <input id="updatepenetrationTestingPlanFile"
                       type="file"
                       (change)="addSapProfileAttachments($event, 3)"
                       name="updatepenetrationTestingPlanFile"
                       style="display: none;" />
              </label>
              <label class="mat-button mat-raised-button"
                     mwlConfirmationPopover
                     [title]="'Remove Penetration Testing Plan and Methodology'"
                     [popoverMessage]="'You are going to remove Penetration Testing Plan and Methodology. Are you sure?'"
                     [appendToBody]="true"
                     [confirmText]="'Yes'" [cancelText]="'No'" placement="top" (confirm)="penetrationTestingPlan=null">
                <i class="pi pi-trash"></i>
                Remove Penetration Testing Plan and Methodology
              </label>
            </div>
          </div>
          <p style="font-size:16px;">
            <strong>
              d. SCR Forms and Supporting Documents
            </strong>
          </p>
          <div style="margin-bottom: 10px">
            <div *ngIf="!scrForm">
              <label class="mat-button mat-raised-button" for="addscrFormFile">
                <i class="pi pi-paperclip"></i> Attach SCR Forms and Supporting Documents
                <input id="addscrFormFile"
                       type="file"
                       (change)="addSapProfileAttachments($event, 4)"
                       name="addscrFormFile"
                       style="display: none;" />
              </label>
            </div>
            <div *ngIf="scrForm">
              <span (click)="downloadAttachmentFile(4)"
                    class="btn btn-link">
                <img style="max-width: 100px; max-height: 100px;"
                     [attr.src]="api + '/api/attachments/file?name='+ window.encodeURIComponent(this.scrFormFile) + '&path=Account/IT%20Profile&token=' + token" />
                {{ scrForm }}
              </span>
              <label class="mat-button mat-raised-button" for="updatescrFormFile">
                <i class="pi pi-paperclip"></i> Upload new SCR Forms and Supporting Documents
                <input id="updatescrFormFile"
                       type="file"
                       (change)="addSapProfileAttachments($event, 4)"
                       name="updatescrFormFile"
                       style="display: none;" />
              </label>
              <label class="mat-button mat-raised-button"
                     mwlConfirmationPopover
                     [title]="'Remove SCR Forms and Supporting Documents'"
                     [popoverMessage]="'You are going to remove SCR Forms and Supporting Documents. Are you sure?'"
                     [appendToBody]="true"
                     [confirmText]="'Yes'" [cancelText]="'No'" placement="top" (confirm)="scrForm=null">
                <i class="pi pi-trash"></i>
                Remove SCR Forms and Supporting Documents
              </label>
            </div>
          </div>

          <p style="font-size:16px;">
            <strong>
              e. SCR Inventory
            </strong>
          </p>
          <div style="margin-bottom: 10px">
            <div *ngIf="!scrInventory">
              <label class="mat-button mat-raised-button" for="addscrInventoryFile">
                <i class="pi pi-paperclip"></i> Attach Penetration Testing Plan and Methodology
                <input id="addscrInventoryFile"
                       type="file"
                       (change)="addSapProfileAttachments($event, 5)"
                       name="addscrInventoryFile"
                       style="display: none;" />
              </label>
            </div>
            <div *ngIf="scrInventory">
              <span (click)="downloadAttachmentFile(5)"
                    class="btn btn-link">
                <img style="max-width: 100px; max-height: 100px;"
                     [attr.src]="api + '/api/attachments/file?name='+ window.encodeURIComponent(this.scrInventory) + '&path=Account/IT%20Profile&token=' + token" />
                {{ scrInventory }}
              </span>
              <label class="mat-button mat-raised-button" for="updatescrInventoryFile">
                <i class="pi pi-paperclip"></i> Upload new Penetration Testing Plan and Methodology
                <input id="updatescrInventoryFile"
                       type="file"
                       (change)="addSapProfileAttachments($event, 5)"
                       name="updatescrInventoryFile"
                       style="display: none;" />
              </label>
              <label class="mat-button mat-raised-button"
                     mwlConfirmationPopover
                     [title]="'Remove SCR Inventory'"
                     [popoverMessage]="'You are going to remove SCR Inventory. Are you sure?'"
                     [appendToBody]="true"
                     [confirmText]="'Yes'" [cancelText]="'No'" placement="top" (confirm)="scrInventory=null">
                <i class="pi pi-trash"></i>
                Remove SCR Inventory
              </label>
            </div>
          </div>

          <p style="font-size:16px;">
            <strong>
              f. Excel File using the FedRAMP Standard Inventory
            </strong>
          </p>
          <div style="margin-bottom: 10px">
            <div *ngIf="!standardInventory">
              <label class="mat-button mat-raised-button" for="addstandardInventoryFile">
                <i class="pi pi-paperclip"></i> Attach FedRAMP Standard Inventory File
                <input id="addstandardInventoryFile"
                       type="file"
                       (change)="addSapProfileAttachments($event, 6)"
                       name="addstandardInventoryFile"
                       style="display: none;" />
              </label>
            </div>
            <div *ngIf="standardInventory">
              <span (click)="downloadAttachmentFile(6)"
                    class="btn btn-link">
                <img style="max-width: 100px; max-height: 100px;"
                     [attr.src]="api + '/api/attachments/file?name='+ window.encodeURIComponent(this.standardInventory) + '&path=Account/IT%20Profile&token=' + token" />
                {{ standardInventory }}
              </span>
              <label class="mat-button mat-raised-button" for="updatestandardInventoryFile">
                <i class="pi pi-paperclip"></i> Upload new file
                <input id="updatestandardInventoryFile"
                       type="file"
                       (change)="addSapProfileAttachments($event, 6)"
                       name="updatestandardInventoryFile"
                       style="display: none;" />
              </label>
              <label class="mat-button mat-raised-button"
                     mwlConfirmationPopover
                     [title]="'Remove Penetration Testing Plan and Methodology'"
                     [popoverMessage]="'You are going to remove FedRAMP Standard Inventory File. Are you sure?'"
                     [appendToBody]="true"
                     [confirmText]="'Yes'" [cancelText]="'No'" placement="top" (confirm)="standardInventory=null">
                <i class="pi pi-trash"></i>
                Remove FedRAMP Standard Inventory File
              </label>
            </div>
          </div>
          <div>
            <button mat-raised-button
                    matStepperPrevious
                    type="button">
              Back
            </button>
            <button mat-raised-button
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button
                    (click)="onDone()">
              Save
            </button>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
  </div>
</form>

<p-dialog header="Assessment Scope"
          [(visible)]="scopeDialogVisible"

          showEffect="fade"
          [formGroup]="scopeFormGroup">

  <mat-form-field class="dialog-control-width">
    <mat-label>FedRAMP Package ID</mat-label>
    <input matInput

           name="role"
           required
           formControlName="packageId">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>CSP Name</mat-label>
    <input matInput

           name="role"
           required
           formControlName="cspName">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>CSO Name</mat-label>
    <input matInput

           name="role"
           required
           formControlName="csoName">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <p-footer>
    <alert></alert>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
      <button mat-raised-button
              (click)="saveScope()">
        Save
      </button>


      <button mat-raised-button
              (click)="scopeDialogVisible = false; editedScope = null">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>


<p-dialog header="Assessment Location"
          [(visible)]="locationDialogVisible"

          showEffect="fade"
          [formGroup]="locationFormGroup">

  <mat-form-field class="dialog-control-width">
    <mat-label>Name</mat-label>
    <input matInput

           name="role"
           required
           formControlName="name">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Address</mat-label>
    <input matInput

           name="role"
           required
           formControlName="address">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Description of Components</mat-label>
    <input matInput

           name="role"
           required
           formControlName="description">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <p-footer>
    <alert></alert>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
      <button mat-raised-button
              (click)="saveLocation()">
        Save
      </button>


      <button mat-raised-button
              (click)="locationDialogVisible = false; editedLocation = null">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog header="Exclusions for Role Testing"
          [(visible)]="roleTestingExclusionDialogVisible"

          showEffect="fade"
          [formGroup]="roleTestingExclusionFormGroup">

  <mat-form-field class="dialog-control-width">
    <mat-label>Role Type</mat-label>
    <input matInput

           name="role"
           required
           formControlName="roleType">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Reason for Exclusion</mat-label>
    <input matInput

           name="role"
           required
           formControlName="exclusionReason">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <p-footer>
    <alert></alert>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
      <button mat-raised-button
              (click)="saveRoleTestingExclusion()">
        Save
      </button>


      <button mat-raised-button
              (click)="roleTestingExclusionDialogVisible = false; editedRoleTestingExclusion = null">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog header="Security Assessment Team"
          [(visible)]="securityAssessmentDialogVisible"

          showEffect="fade"
          [formGroup]="securityAssessmentFormGroup">

  <mat-form-field class="dialog-control-width">
    <mat-label>Name</mat-label>
    <input matInput

           name="role"
           required
           formControlName="name">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Assessment Role</mat-label>
    <input matInput

           name="role"
           required
           formControlName="role">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Validated by IA</mat-label>
    <input matInput

           name="role"
           required
           formControlName="validatedByIA">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Validated by CSP</mat-label>
    <input matInput

           name="role"
           required
           formControlName="validatedByCSP">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <p-footer>
    <alert></alert>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
      <button mat-raised-button
              (click)="saveSecurityAssessment()">
        Save
      </button>


      <button mat-raised-button
              (click)="securityAssessmentDialogVisible = false; editedSecurityAssessment = null">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog header="Point of Contact"
          [(visible)]="contactDialogVisible"

          showEffect="fade"
          [formGroup]="contactFormGroup">

  <mat-form-field class="dialog-control-width">
    <mat-label>Name</mat-label>
    <input matInput

           name="role"
           required
           formControlName="name">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Role</mat-label>
    <input matInput

           name="role"
           required
           formControlName="role">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <p-footer>
    <alert></alert>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
      <button mat-raised-button
              (click)="saveContact()">
        Save
      </button>


      <button mat-raised-button
              (click)="contactDialogVisible = false; editedContact = null">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog header="Assessment Tool"
          [(visible)]="assessmentToolDialogVisible"

          showEffect="fade"
          [formGroup]="assessmentToolFormGroup">

  <mat-form-field class="dialog-control-width">
    <mat-label>Name</mat-label>
    <input matInput

           name="role"
           required
           formControlName="name">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Vendor/Organization Name & Version</mat-label>
    <input matInput

           name="role"
           required
           formControlName="vendor">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Purpose of Tool</mat-label>
    <input matInput

           name="role"
           required
           formControlName="purpose">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <p-footer>
    <alert></alert>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
      <button mat-raised-button
              (click)="saveAssessmentTool()">
        Save
      </button>


      <button mat-raised-button
              (click)="assessmentToolDialogVisible = false; editedAssessmentTool = null">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog header="Testing Performed Through Manual Methods"
          [(visible)]="testDialogVisible"

          showEffect="fade"
          [formGroup]="testFormGroup">

  <mat-form-field class="dialog-control-width">
    <mat-label>Test ID</mat-label>
    <input matInput

           name="role"
           required
           formControlName="testId">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Test Name</mat-label>
    <input matInput

           name="role"
           required
           formControlName="testName">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Description</mat-label>
    <input matInput

           name="role"
           required
           formControlName="description">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <p-footer>
    <alert></alert>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
      <button mat-raised-button
              (click)="saveTest()">
        Save
      </button>


      <button mat-raised-button
              (click)="testDialogVisible = false; editedTest = null">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog header="Mandatory and Additional Attack Vector"
          [(visible)]="attackVectorDialogVisible"

          showEffect="fade"
          [formGroup]="attackVectorFormGroup">

  <mat-checkbox formControlName="include">Include</mat-checkbox>

  <mat-form-field class="dialog-control-width">
    <mat-label>Name</mat-label>
    <input matInput

           name="role"
           required
           formControlName="name">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Type</mat-label>
    <mat-select formControlName="attackVectorKind">
      <mat-option [value]="0">Mandatory Attack Vector</mat-option>
      <mat-option [value]="1">Internet based (Untrusted)</mat-option>
      <mat-option [value]="2">CSP Corporate (Untrusted and Trusted)</mat-option>
      <mat-option [value]="3">Internal Threat (Untrusted and Trusted)</mat-option>
      <mat-option [value]="4">Enterprise</mat-option>
      <mat-option [value]="5">Mobile</mat-option>
    </mat-select>
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <p-footer>
    <alert></alert>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
      <button mat-raised-button
              (click)="saveAttackVector()">
        Save
      </button>


      <button mat-raised-button
              (click)="attackVectorDialogVisible = false; editedAttackVector = null">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog header="Role Based Testing"
          [(visible)]="roleTestingDialogVisible"

          showEffect="fade"
          [formGroup]="roleTestingFormGroup">

  <mat-form-field class="dialog-control-width">
    <mat-label>Role Name</mat-label>
    <input matInput

           name="role"
           required
           formControlName="roleName">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Test User ID</mat-label>
    <input matInput

           name="role"
           required
           formControlName="testUserId">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Associated Functions</mat-label>
    <input matInput

           name="role"
           required
           formControlName="associatedFunctions">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <p-footer>
    <alert></alert>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
      <button mat-raised-button
              (click)="saveRoleTesting()">
        Save
      </button>


      <button mat-raised-button
              (click)="roleTestingDialogVisible = false; editedRoleTesting = null">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>

